module.exports = __webpack_public_path__ + "static/media/banner_2.fa393441.png";